import _ from 'lodash';
import * as ActionTypes from '../actions/actionTypes';
import overlays from '../config/overlays';

const initialState = { layers: _.sortBy(overlays, ['display_name']), active: {} };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.TOGGLE_OVERLAY: {
      const newLayers = state.layers.map((value) => {
        const new_value = { ...value };
        if (value.id === action.id) {
          new_value.active = !value.active;
        }
        return new_value;
      });
      return {
        layers: newLayers,
        active: _.mapValues(_.keyBy(newLayers, 'id'), 'active')
      };
    }

    case ActionTypes.ACTIVATE_OVERLAY: {
      const newLayers = state.layers.map((value) => {
        const new_value = { ...value };
        if (value.id === action.id) {
          new_value.active = true;
        }
        return new_value;
      });
      return {
        layers: newLayers,
        active: _.mapValues(_.keyBy(newLayers, 'id'), 'active')
      };
    }

    case  ActionTypes.RESET_LAYERS:
      return { ...initialState };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/overlays.js